import { getDataJoinedByComma } from '@utils/trackingUtils';

export default function getPaymentInfo(paymentMethods = []) {
  const hasOnDeliveryMethod = paymentMethods.some(method => !method.online);
  const onlineMethods = getDataJoinedByComma(
    paymentMethods.filter(method => method.online),
    'id',
  );
  return `${hasOnDeliveryMethod}-${onlineMethods || false}`;
}
